export const PRIVATE_FLEET = 3
export const COMPANY_DRIVER = 4
export const OWNER_OPERATOR = 5
export const CONTRACTOR = 6
export const MOTOR_CARRIER = 7

const entitiTypes = new Map()
entitiTypes.set(PRIVATE_FLEET, 'Private Fleet')
entitiTypes.set(COMPANY_DRIVER, 'Company Driver')
entitiTypes.set(OWNER_OPERATOR, 'Owner Operator')
entitiTypes.set(CONTRACTOR, 'Contractor')
entitiTypes.set(MOTOR_CARRIER, 'Motor Carrier')

export const getEntitiyType = (id) => {
  return entitiTypes.get(id)
}

export const getBusinessEntityTypes = () => {
  return [MOTOR_CARRIER, PRIVATE_FLEET]
}

export const getIndividualEntityTypes = () => {
  return [COMPANY_DRIVER, OWNER_OPERATOR, CONTRACTOR]
}
